import styled, { css } from 'styled-components';
import text from '../../GlobalStyles/theme/text';

export type TextType = keyof typeof text;

export const textStyle = (textType: TextType) => css`
    font: ${({ theme }) => `${theme[textType].fontSize} ${theme[textType].fontFamily}`};
    letter-spacing: ${({ theme }) => theme[textType].letterspacing};
`;

export const StyledLabel = styled.label<{ textType: TextType }>`
    ${({ textType }) => textStyle(textType)}
`;

export const StyledText = styled.div<{ textType: TextType }>`
    ${({ textType }) => textStyle(textType)}
`;

export const StyledHeaderText = styled.h1<{ textType: TextType }>`
    ${({ textType }) => textStyle(textType)}
`;

export const StyledTextSpan = styled.span<{ textType: TextType }>`
    ${({ textType }) => textStyle(textType)}
    line-height: ${({ theme, textType }) => theme[textType].lineHeight};
`;

export const StyledSuccessTextSpan = styled(StyledTextSpan)`
    color: ${({ theme }) => theme.colors.turquoise100};
`;

export const StyledErrorTextSpan = styled(StyledTextSpan)`
    color: ${({ theme }) => theme.colors.red90};
`;

export const StyledTextBlock = styled.p<{ textType: TextType }>`
    ${({ textType }) => textStyle(textType)}
`;

export const StyledFilterLabel = styled(StyledLabel)<{ hasErrors?: boolean }>`
    color: ${({ theme }) => theme.colors.charcoal100};
    padding-left: 10px;
    width: 100%;
    ${({ hasErrors, theme }) =>
        hasErrors &&
        css`
            color: ${theme.colors.red90};
        `}
`;

export const textEllipsisCss = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export default StyledText;
